module.exports = __webpack_public_path__ + "media/images/eu10-9317dcccfb6206262395c52acf46a796.svg";